console.log('Vite ⚡️ Rails')

import * as Turbo from "@hotwired/turbo"
import "../controllers"

import "@fortawesome/fontawesome-free/js/all"

import * as bootstrap from 'bootstrap'

import { DateTime } from "luxon";
window.DateTime = DateTime;

import {TabulatorFull as Tabulator} from 'tabulator-tables'
window.Tabulator = Tabulator

// Initialize Bootstrap tooltips on page load
document.addEventListener("turbo:load", () => {
  var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
  tooltipTriggerList.map(function (element) {
    let value = new bootstrap.Tooltip(element)
    Object.defineProperty(element, "Tooltip", {
      configurable: true,
      writable: false,
      value
    })
    return value
  })
});

window.bootstrap = bootstrap

import "../channels"

import toastr from 'toastr'
window.toastr = toastr
